export default [
  {
    path: "incidence",
    name: "incidence",
    component: (): Promise<any> => import(/* webpackChunkName: "advertiser:incidence" */ "@/views/Advertiser/IncidenceView.vue")
  }
];
